import React from 'react';
import { useModel } from 'src/client/js/view/hooks';
import Footer from '../Footer';
import FooterII from '../FooterII';
import logger from 'src/logger';

const FooterMain = () => {
  const { prismicFooterModel, prismicFooterIIModel } = useModel();

  if (!prismicFooterModel && !prismicFooterIIModel) {
    logger.error('No Prismic footer document was found.');
    return null;
  }

  return (
    <div>
      {prismicFooterIIModel ? <FooterII {...prismicFooterIIModel} /> : <Footer  />}
    </div>
  );
};

export default FooterMain;
